import { Component, OnInit, HostListener } from '@angular/core';
declare var $: any;
declare var jquery: any;
import { GridApi, GridOptions, GridReadyEvent } from "ag-grid/main";
import { AdminService, AssessmentPurchaseDto, AdminPurchaseDto, AdminAssessmentPurchaseDto } from 'app/services/admin/AdminService';
import { CoachService } from 'app/services/coach/CoachService';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'app/globals';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
    

    @HostListener('keydown', ['$event'])
    onKeyDown(e: any) {
        if (e.target.inputMode == 'numeric') {
            if (
                // Allow: Delete, Backspace, Tab, Escape, Enter
                [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
                (e.keyCode === 65 && e.ctrlKey === true) || // Allow: Ctrl+A
                (e.keyCode === 67 && e.ctrlKey === true) || // Allow: Ctrl+C
                (e.keyCode === 86 && e.ctrlKey === true) || // Allow: Ctrl+V
                (e.keyCode === 88 && e.ctrlKey === true) || // Allow: Ctrl+X
                (e.keyCode === 65 && e.metaKey === true) || // Cmd+A (Mac)
                (e.keyCode === 67 && e.metaKey === true) || // Cmd+C (Mac)
                (e.keyCode === 86 && e.metaKey === true) || // Cmd+V (Mac)
                (e.keyCode === 88 && e.metaKey === true) || // Cmd+X (Mac)
                (e.keyCode >= 35 && e.keyCode <= 40) // Home, End, Left, Right
            ) {
                return;  // let it happen, don't do anything
            }
            // Ensure that it is a number and stop the keypress
            if (
                (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
                (e.keyCode < 96 || e.keyCode > 105)
            ) {
                e.preventDefault();
            }
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: any) {
        if (event.target.inputMode == 'numeric') {
            event.preventDefault();
            const pastedInput: string = event.clipboardData
                .getData('text/plain')
                .replace(/\D/g, ''); // get a digit-only string
            document.execCommand('insertText', false, pastedInput);
        }
    }
    @HostListener('drop', ['$event'])
    onDrop(event: any) {
        if (event.target.inputMode == 'numeric') {
            event.preventDefault();
            const textData = event.dataTransfer
                .getData('text').replace(/\D/g, '');
            //this.inputElement.focus();
            document.execCommand('insertText', false, textData);
        }
    }

    quantity: number = 0;
    quantity360: number = 0;

    data: string[] = [];
    dataHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;
    loading: boolean = false;
    canAdd: boolean = false;
    canReset: boolean = false;
    passwordIsValid = 0;
    userForm: FormGroup;
    myColors = ['#8b0000', '#FF6D00', '#ffa500', '#AEEA00', '#00C853'];
    selectedUserId: number;
    selected_client: string = "";
    public pageNumber = 1;
    public pageSize = 25
    public fetchingUsers = false;
    public filteringUsers = false;
    public totalUsers = 0;
    public totalPages = 0;
    public firstNameFilter: string;
    public lastNameFilter: string;
    public emailFilter: string;
    public userTypeFilter: string;
    private filterModel: any;

    constructor(
        private _AdminService: AdminService,
        private _CoachService: CoachService,
        private _Globals: Globals,
        private _toastr: ToastrService,
        private _CryptoJs: CryptoJs,
        private fb: FormBuilder,
        private _Router: Router
    ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";

        this.userForm = this.fb.group({
            'password1': ['', Validators.required],
            'password2': ['', Validators.required],
        });

        this.userForm.controls['password2'].setValidators([
            Validators.required,
            this.notEquals.bind(this.userForm)
        ]);

        this.userForm.controls['password2'].valueChanges.
            subscribe(data => {
                console.log(data);
                this.notEquals(this.userForm.controls.password2);
            });
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.gridOptions.onFilterChanged = ((event) => {
            return;
        })

        this.gridOptions.onFilterModified = ((event) => {
            const firstName = event.api.getFilterInstance('FirstName').getModel() ?? null as {filter: string, filterType: string, type: string};
            const lastName = event.api.getFilterInstance('LastName').getModel() ?? null as {filter: string, filterType: string, type: string};
            const email = event.api.getFilterInstance('Email').getModel() ?? null as {filter: string, filterType: string, type: string};
            const userType = event.api.getFilterInstance('UserTypeName').getModel() ?? null as {filter: string, filterType: string, type: string};
            
            this.firstNameFilter = undefined;
            if(firstName) {
                this.firstNameFilter = firstName.filter;
            }

            this.lastNameFilter = undefined;
            if(lastName) {
               this.lastNameFilter = lastName.filter;
            } 

            this.emailFilter = undefined;
            if(email) {
                this.emailFilter = email.filter;
            }

            this.userTypeFilter = undefined;
            if(userType) {
                this.userTypeFilter = userType.filter;
            }

            const reload = true;
            this.filterModel = event.api.getFilterModel();
            this.filteringUsers = true;
            this.firstPage(reload);

        });

        this.dataHeaders = this.createHeaders();

        this.getUsers();        
    }

    getUsers() {
        this.loading = true;
        
        this._AdminService.getPagedUsers(
            this.pageNumber, 
            this.pageSize, 
            this.firstNameFilter, 
            this.lastNameFilter, 
            this.emailFilter, 
            this.userTypeFilter).subscribe((response) => {
            if (this._Globals.validationToken(response.result.Result)) {
                if (response.result.Result === 1) {
                    const data = JSON.parse(response.result.Data) as {users: Array<any>, totalUsers: number};
                    this.data = data.users;
                    this.totalUsers = data.totalUsers;
                    this.totalPages = Math.ceil(data.totalUsers / this.pageSize);

                    if (this.totalUsers === 0) {
                        this.pageNumber = 0;
                    }
                } else {
                    this._toastr.error('We are sorry. An error happened when trying to get users.', 'ELI');
                    return;
                }
            }
            this.loading = false;
        },
        (error) => {
            this._toastr.error('We are sorry. An error happened when trying to get users.', 'ELI');
        },
        () => {
            this.fetchingUsers = false; 
            if (this.gridApi && this.filterModel) {
                setTimeout(() => {
                    this.gridApi.setFilterModel(this.filterModel);
                });
            }
        });
    }

    createHeaders() {
        let columnDefs = new Array();

        let idHeader = {
            headerName: 'Id',
            field: 'Id',
            sort: 'asc',
            minWidth: 100,
            width: 100,
            hide:true,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(idHeader);

        let fistNameHeader = {
            headerName: 'First Name',
            field: 'FirstName',
            //headerCheckboxSelection: false,
            //headerCheckboxSelectionFilteredOnly: false,
            //checkboxSelection: true,
            minWidth: 175,
            width: 175,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(fistNameHeader);

        let lastNameHeader = {
            headerName: 'Last Name',
            field: 'LastName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(lastNameHeader);

        let emailHeader = {
            headerName: 'Email',
            field: 'Email',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(emailHeader);

        let userTypeHeader = {
            headerName: 'User Type',
            field: 'UserTypeName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            suppressSorting: true,
            suppressMenu: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(userTypeHeader);

        return columnDefs;
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
    }

    sizeToFit() {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params: GridReadyEvent) {
        const paginator = document.getElementById('customPaginator');
        document.getElementsByClassName('ag-root ag-font-style ag-layout-normal')[0].appendChild(paginator);

        this.gridApi = params.api;
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    public onRowClicked(e) {
        console.log(e);
        this._Router.navigate(['/app/user_personal_data/' + e.data.Id]);
    }

    getSelectedRows(): any {
        console.log("SELECTED", this.gridApi.getSelectedRows());
        return this.gridApi.getSelectedRows();
    }


    deselectAllCheckBox() {
        this.canAdd = false;
        this.gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        let rows = this.getSelectedRows();
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount > 15) {
            this.gridApi.forEachNode((node) => {
                //let contains = this.containsObject(node.data.Id, this.selectedClients);
                node.setSelected(false);
            });
            this._toastr.warning('To many users selected.', 'ELI');
            return;
        }

        if (rowCount > 0) {
            let isClientSelected = false;

            rows.forEach((user) => {
                console.log(user);
                this.selected_client = user.Email;
                this.selectedUserId = user.Id;
                if (user.UserTypeName == "Client" || user.UserTypeName == "Rater") {
                    isClientSelected = true;
                    return;
                }
            });

            if (!isClientSelected) {
                this.canAdd = true;
            } else {
                this.canAdd = false;
                if (rowCount == 1) {
                    this.canReset = true;
                } else {
                    this.canReset = false;
                }
            }

        } else {
            this.canAdd = false;
            this.canReset = false;
        }


    }

    showUsersAssignAssessmentsModal() {
        if (this.canAdd) {
            $("#usersAssignAssessmentsModal").modal({ backdrop: "static" });
            $('#usersAssignAssessmentsModal').modal('show');
            //$('#quantity').val(1);
            //$('#quantity360').val(1);
            this.quantity = 0;
            this.quantity360 = 0;
        }
    }

    hideUsersAssignAssessmentsModal() {
        $('#usersAssignAssessmentsModal').modal('hide');
    }

    saveAssessmentAssignmentByAdmin() {
        let purchaseArray: AdminAssessmentPurchaseDto[] = [];
        let selected = this.getSelectedRows();

        selected.forEach((x) => {
            purchaseArray.push({
                "LU0": x.Id,
                "LU7": 0,
                "LU5": this._Globals.getUserId(),
                "LU4": "",
                "LU3": [
                    {
                        "X2": 1,
                        "X5": parseInt($('#quantity').val()),
                        "X9": 0
                    }, {
                        "X2": 34,
                        "X5": parseInt($('#quantity360').val()),
                        "X9": 0
                    }]
            });
        });

        console.log(purchaseArray);

        this._AdminService.postSaveAssessmentAssignmentByAdmin(purchaseArray).subscribe((data: any) => {
            console.log('response_postSaveAssessmentAssignmentByAdmin', data);
            if (this._Globals.validationToken(data.result.Result)) {
                console.log('_data', data);
                if (data.result.Result == 1) {
                    this._toastr.success('Assessments assigned successfully.', 'ELI');
                } else {
                    this._toastr.error('We are sorry. An error happened when trying to complete the purchase process.', 'ELI');
                }
            }

            this.deselectAllCheckBox();
            this.hideUsersAssignAssessmentsModal();

        });
    }

    allowOnlyNumber(evt: any) {
        var charCode = evt.keyCode;
        console.log(charCode);
        //if ((charCode > 31 && (charCode < 48 || charCode > 57)) || (parseInt(evt.target.value) <= 0)) {
        //if (charCode < 96 || charCode > 105 || (parseInt(evt.target.value) <= 0)) {
        if (parseInt(evt.target.value) <= 0 || evt.target.value == "") {
            $('#' + evt.target.id).val(0);
            if (evt.target.id == 'quantity') { this.quantity = 0; } else this.quantity360 = 0;
            return false;
        } else {
            return true;
        }
        //}else {
        //    return true;
        //}

    }

    resetPassword() {      

        if (this.passwordIsValid < 3) {
            this._toastr.warning('Password is not strong enough');
            return;
        }

        if (this.userForm.value.password1 !== this.userForm.value.password2) {
            this._toastr.warning('Password confirm does not match');
            return;
        }

        let data = {
            "n5": this.selectedUserId,
            "j1": this.userForm.value.password1
        };
        $('body').css('cursor', 'progress');
        this._AdminService.postAdminResetPassword(this._CryptoJs.encrypt(JSON.stringify(data), 'Ks6u9y$B&EXH@PcQfTjWnZP4t33!z%7*')).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                //let _data = JSON.parse(data.result);
                console.log('postAdminResetPassword_response', data.result.Result);

                switch (data.result.Result) {
                    case -2:
                        //-2 No user found.
                        this._toastr.warning("The selected user is either a coach or a student. You cannot reset the password for such user types by using this option", 'ELI');
                        break;
                    case -1:
                        //-1 Entered password is the same at the one at the invitation email.
                        this._toastr.warning("We are sorry. We couldn't find the selected user at the database", 'ELI');
                        break;
                    case 0:
                        //0 : Error.
                        this._toastr.error('We are sorry. An unexpected error happened when trying to reset the selected user password', 'ELI');
                        break;
                    case 1:
                        //1 : Ok.Entered password is different from the one at the invitation email.No message to show
                        this._toastr.success('Password reset successfully');
                        break;
                }
                this.hideResetModal();
                this.deselectAllCheckBox();
                $('body').css('cursor', 'default');
            }
        });
    }

    notEquals(control): any {

        let form: any = this;

        //console.log('control', control);

        if (form.userForm == undefined) return;

        if (control.value !== form.userForm.controls['password1'].value) {
            $('.pass2').removeClass('passMatch');
            $('.pass2').addClass('passNotMatch');

            return {
                notEquals: true
            }
        } else {
            $('.pass2').removeClass('passNotMatch');
            $('.pass2').addClass('passMatch');
        }


        return null;
    }

    showResetPasswordModal() {
        if (this.resetPassword) {
            $("#resetPasswordModal").modal({ backdrop: "static" });
            $('#resetPasswordModal').modal('show');
        }
        
    }

    hideResetModal() {
        $('#password1').val('');
        $('#password2').val('');
        $('#resetPasswordModal').modal('hide');
    }

    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $(`#${tagId}`).val('');
        }
    }

    passwordValid(event) {
        console.log(event);
        this.passwordIsValid = event;
        switch (event) {
            case null:
                $('#passWordText').css('color', 'black');
                $('#passWordText').css('display', 'block');
                break

            case 0:
            case 1:
            case 2:
                $('#passWordText').css('color', 'red');
                $('#passWordText').css('display', 'block');
                break;
            case 3:
            case 4:
                $('#passWordText').css('display', 'none');
                break;
        }
        console.log(this.userForm);
        this.notEquals(this.userForm.controls.password2);
    }

    public firstPage(relaod: boolean = false): void {
        if (this.pageNumber <= 1 && !relaod) {
            return;
        }

        this.fetchUsers('first');
    }

    public previousPage(): void {
        if (this.pageNumber <= 1) {
            return;
        }

        this.fetchUsers('previous');
    }

    public nextPage(): void {
        if (this.pageNumber === this.totalPages) {
            return;
        }

        this.fetchUsers('next');
    }

    public lastPage(): void {
        if (this.pageNumber === this.totalPages) {
            return;
        }

        this.fetchUsers('last');
    }

    public fetchUsers(action: 'first' | 'previous' | 'next' | 'last'): void {
        if (this.fetchingUsers) {
            return;
        }

        this.fetchingUsers = true;
        switch(action) {
            case 'first':
                this.pageNumber = 1;
                break;
            case 'previous': 
                this.pageNumber -= 1;
                break;
            case 'next':
                this.pageNumber += 1;
                break;
            case 'last':
                this.pageNumber = this.totalPages;
                break;
        }

        this._AdminService.getPagedUsers(
            this.pageNumber, 
            this.pageSize, 
            this.firstNameFilter, 
            this.lastNameFilter, 
            this.emailFilter, 
            this.userTypeFilter).subscribe((response) => {

            if (this._Globals.validationToken(response.result.Result)) {
                if (response.result.Result === 1) {
                    const data = JSON.parse(response.result.Data) as {users: Array<any>, totalUsers: number};
                    
                    this.data = data.users;
                    this.totalUsers = data.totalUsers;
                    this.totalPages = Math.ceil(data.totalUsers / this.pageSize);
                    
                    if (this.totalUsers === 0) {
                        this.pageNumber = 0;
                    }
                } else {
                    this._toastr.error('We are sorry. An error happened when trying to get users.', 'ELI');
                    this.fetchingUsers = false;
                    this.filteringUsers = false;
                }
                
            } else {
                this._toastr.error('We are sorry. An error happened when trying to get users.', 'ELI');
                this.fetchingUsers = false;
                this.filteringUsers = false;

            }
        },
        (error) => {
            this._toastr.error('We are sorry. An error happened when trying to get users.', 'ELI');
                this.fetchingUsers = false;
                this.filteringUsers = false; 
        },
        () => {
            this.fetchingUsers = false; 
            this.filteringUsers = false; 
            if (this.gridApi && this.filterModel) {
                setTimeout(() => {
                    this.gridApi.setFilterModel(this.filterModel);
                });
            }
        }); 
    }
}
